<template>
  <div class="commonLiStyle">
    <top-component></top-component>
    <!-- <div class="bannerFirst" @click="ComeLive"></div> -->
    <div class="commonLiContainer">
      <MyAside></MyAside>
      <div class="commontent">
        <div class="titleMap">图书消毒柜</div>
        <div class="letterTitle">2020/4/12    23:00</div>
        <img src="../../assets/images/xiaodu-1.png">
        <div class="threediv">
          品牌：集迎
        </div>
        <div class="threediv">
          产品型号：JY-0001
        </div>
        <div class="threediv">
          一、工作原理
        </div>
        <div class="threediv">
          1、技术背景
        </div>
        <div class="threediv">
          国家卫生健康委办公厅发布的《新型冠状病毒感染的肺炎诊疗方案》(试行第五版)中指出，新型冠状病毒对紫外线和热敏感。
        </div>
        <div class="threediv">
          紫外线是大部分微生物的天敌，可以轻轻松松将它们杀死。非典时期，专家们就发现，使用强度大于90μW/cm2的紫外线照射，可以杀灭SARS病毒。
        </div>
        <div class="threediv">
          研究发现，新型冠状病毒与SARS病毒存在相关性，科学合理的使用紫外线是可有效杀灭新型冠状病毒的。
        </div>
        <div class="threediv">
          紫外线其实就是电磁波谱中波长在100-400纳米之间的辐射，和红外线一样，无法被人眼看到。紫外线可以破坏微生物体内的DNA与RNA结构，使病毒、细菌等微生物体内的遗传物质发生断裂、交联或形成光化产物。
        </div>
        <div class="threediv">
          同时，紫外线也可以作用于细胞内的氧原子，使其形成具有杀伤力的活性氧自由基，这些都能造成微生物细胞无法增殖或直接死亡。
        </div>
        <div class="threediv">
          新型冠状病毒的遗传物质是RNA，紫外线可以作用于病毒的遗传物质，导致病毒的RNA断裂，使其不能正常合成所需的蛋白质，从而杀灭病毒。
        </div>
        <div class="threediv">
          2、产品工作原理
        </div>
        <div class="threediv">
          气旋式逐翻动书页，使图书充分展开，吹出书中杂物，消毒无死角，更彻底；
        </div>
        <div class="threediv">
          内置强短波紫外线灯，产生UV-C紫外线中最强波长254NM的紫外线，在密闭环境的反射下，可以达到二次反射消毒；
        </div>
        <div class="threediv">
          独立的静电除尘系统（粉尘过滤），清除图书内部粉尘，图书消毒效果更加显著；
        </div>
        <div class="threediv">
          内置香薰杀菌精油，通过风流循环，进入杀菌工作室，抑制病毒以及细菌滋生。
        </div>
        <div class="threediv">
          二、产品特点
        </div>
        <div class="threediv">
          1、技术参数
        </div>
        <table>
          <tr>
            <td>工作电源：</td>
            <td>AC220V 50HZ</td>
            <td>总功率：</td>
            <td>160W</td>
          </tr>
          <tr>
            <td>工作温度：</td>
            <td>-10~50 度</td>
            <td>工作湿度：</td>
            <td>10%~90%</td>
          </tr>
          <tr>
            <td>单门紫外线功率：</td>
            <td>4支总共24W</td>
            <td>待机功率：</td>
            <td>18W</td>
          </tr>
          <tr>
            <td>消毒杀菌工作原理：</td>
            <td>253.7nm紫外线杀菌</td>
            <td>灭菌时间：</td>
            <td>30秒至90秒</td>
          </tr>
          <tr>
            <td>操作显示方式：</td>
            <td>4.3寸彩色触摸液晶屏</td>
            <td>操作按键：</td>
            <td>电容触摸按键</td>
          </tr>
          <tr>
            <td>杀菌率：</td>
            <td>30秒杀菌率99.9%</td>
            <td>过滤网效果：</td>
            <td>可以有效过滤PM2.5等微小粉尘</td>
          </tr>
          <tr>
            <td>紫外线灯管寿命：</td>
            <td>超30000万次消毒</td>
            <td>工作噪音：</td>
            <td>小于50 dB(A)</td>
          </tr>
          <tr>
            <td>杀菌仓：</td>
            <td>上层3本、中层2本</td>
            <td>杀菌仓工作：</td>
            <td>上层、中层可独立工作</td>
          </tr>
          <tr>
            <td>杀菌物品：</td>
            <td>书籍、文档</td>
            <td>杀菌可容纳图书容量：</td>
            <td>单次可放入1-5本书</td>
          </tr>
          <tr>
            <td>柜体材料：</td>
            <td>冷轧钢板</td>
            <td>柜体表面处理：</td>
            <td>喷塑</td>
          </tr>
          <tr>
            <td>产品尺寸：</td>
            <td>550*500*1600MM</td>
            <td>产品重量：</td>
            <td>90KG</td>
          </tr>
        </table>
        <div class="threediv">
          2、产品结构及参数
        </div>
        <img src="../../assets/images/xiaodu-2.png">
        <div class="threediv">
          三、产品功能
        </div>
        <div class="threediv">
          机器满足读者自行操作，达到对图书、文件杀菌消毒的功能。
        </div>
        <div class="threediv">
          1.  杀菌：
        </div>
        <div class="threediv">
          采用紫外线杀菌技术，并搭配天然香精强化杀菌效果。
        </div>
        <div class="threediv">
          2.  自动翻页：
        </div>
        <div class="threediv">
          90°强风定向吹拂，扇形展开图书的每一页纸张，达到同时对书封与内页杀菌效果，并将书页内部灰尘、杂物吹出。
        </div>
        <div class="threediv">
          3.  除异味：
        </div>
        <div class="threediv">
          本机器配备天然香精，能缓解人体压力，祛除书中的霉味等异味，同时可去除图书中的二甲苯，氨等致癌物质，强化杀菌。
        </div>
        <div class="threediv">
          4.  过滤集尘：
        </div>
        <div class="threediv">
          使用独立的静电除尘系统（粉尘过滤），能收集细微灰尘、细菌、病毒，拦截微小分子，不衍生臭氧或二氧化碳等有害物质
        </div>
        <div class="threediv">
          5.  可视化：
        </div>
        <div class="threediv">
          设有抗UV材质透视窗，读者可以实时观看杀菌作业进度，机器具备杀菌作业进度指示灯，可提示杀菌作业的进度。
        </div>
        <div class="threediv">
          6.  设备状态显示：
        </div>
        <div class="threediv">
          真彩屏可以显示机器使用次数，非工作时间，可以播放操作方法及其它宣传视频资料。
        </div>
        <div class="threediv">
          7.  低噪音：
        </div>
        <div class="threediv">
          每次杀菌作业30秒内完成（管理员可调节杀菌时间），杀菌率99.9%。工作噪音低于50分贝。
        </div>
        <div class="threediv">
          8.  人性化操作介面设计
        </div>
        <div class="threediv">
          操作界面具备警示器设计，操作完成或发生错误时可自动发出声响提醒使用者；操作开始与结束有声音提示；耗材有提示更换显示。
        </div>
        <div class="threediv">
          9.  安全性：
        </div>
        <div class="threediv">
          自动阻断装置，杀菌工作时，读者误操作打开柜门，自动停止工作，保护读者不受伤害。
        </div>
        <div class="threediv">
          加装漏电保护装置，设备发生漏电故障时以及对有致命危险的人身触电进行有效保护。
        </div>
        <div class="threediv">
          杀菌作业不会对书籍封面或内页造成刮痕或任何损害痕迹。
        </div>
        <div class="threediv">
          10.自我诊断：
        </div>
        <div class="threediv">
          机器具有开机和运行时自动诊断功能，可以实时监测紫外灯、风扇和触控按钮和面板的运行状况，有故障时自动报警或语音提示。
        </div>
        <div class="threediv">
          11.适用图书范围大：
        </div>
        <div class="threediv">
          操作室内空间小少于 490*460*465mm(长*宽*高)，可以对 16 开、32 开或艺术类等大尺寸的图书进行消毒杀菌；
        </div>
        <div class="threediv">
          四、操作说明：
        </div>
        <div class="threediv">
          1.开启防护门
        </div>
        <div class="threediv">
          轻拉把手开启防护门，请勿使用蛮力开启防护门(开启角度勿超过100度)。
        </div>
        <div class="threediv">
          2.将图书从中平分展开并置于图书固定支架上
        </div>
        <div class="threediv">
          将书页平分展开并置于机器内部之固定支架上。
        </div>
        <div class="threediv">
          请务必平放图书以加强杀菌效果。
        </div>
        <div class="threediv">
          图书固定完成后，请关上防护门。
        </div>
        <div class="threediv">
          3.关闭防护门，按下操作钮，以进行杀菌作业。
        </div>
        <div class="threediv">
          按下操作钮，启动杀菌作业。
        </div>
        <div class="threediv">
          按下操作钮时，该钮会转为蓝色并启动杀菌作业。
        </div>
        <div class="threediv">
          4.杀菌作业完成后，打开防护门并从架上取回图书。
        </div>
        <div class="threediv">
          听到「哔」声响后，或运行指示灯变为白色，打开防护门，并使用双手自架上轻巧地取出图书。
        </div>
        <div class="threediv">
          取回图书后请关闭防护门。
        </div>
        <img src="../../assets/images/xiaodu-3.png">
        <div class="threediv">
          五、售后服务
        </div>
        <div class="threediv">
          本产品硬件无偿保用一年，为购买日起12个月。非正常使用引起的故障，如天灾、错误操作等导致的损坏与故障，不属于无偿质保条件。
        </div>
        <div class="threediv">
          1、购买本公司产品一个月内，在正常使用的情况下，出现性能、功能问题、需重大修理，或3个月内，相同问题出现3次以上严重故障时，可更换新产品。
        </div>
        <div class="threediv">
          2、玻璃、外壳等部位表面上有制造工艺上许可的微小痕迹，不能更换产品。
        </div>
        <div class="threediv">
          3、服务质保
        </div>
        <table>
          <tr>
            <td>项目</td>
            <td>质保时间</td>
          </tr>
          <tr>
            <td>硬件：内装、外装部件，风扇及电源部分</td>
            <td>12个月</td>
          </tr>
          <tr>
            <td>消耗品（灯、过滤器、芳香剂等）</td>
            <td>6个月</td>
          </tr>
        </table>
        <div class="threediv">
          4、灯、过滤器、芳香剂等消耗性部件，自购买日起6个月内可免费更换，超出6个月，属于有偿更换。
        </div>
        <div class="threediv">
          5、请勿擅自拆卸，若因用户任意拆卸或改造本设备，导致不能正常工作，不在本公司不提供售后保障范围。
        </div>
      </div>
    </div>
    <bottom-component></bottom-component>
  </div>
</template>

<script>
  import BottomComponent from '../Components/BottomComponent.vue'
  import TopComponent from '../Components/TopComponent.vue'
  import MyAside from '@/components/MyAside.vue'
  export default {
    name: 'ProductXiaodugui',
    data() {
      return {
      }
    },
    mounted() {
    },
    methods: {
      // 进入直播
      ComeLive() {
        // 1、后台如果设置了默认直播，就传过去默认直播的id，否则就传0
        // 2、HomePage: true; 用来判断是不是从首页进入的，
        // 首页进来的话，优先播放和服务器时间对的上的直播，
        // 其次是查看有没有默认直播，
        // 上面都没有满足的话就展示没有直播提醒的提示
        // 3、直播页中直接点击议程跳转到新的页面，就展示点击的议程的直播 Cookies.set('linkUrl', item.linkUrl) Cookies.get('linkUrl')
        this.$router.push({ name: 'LookLiveG', params: { webinarId: 0 } })
        Cookies.set('HomePage', true)
        Cookies.set('playType', 1)
        Cookies.set('playUrl', 'null')
      }
    },
    components: {
      BottomComponent,
      TopComponent,
      [MyAside.name]: MyAside
    },
  }
</script>

<style scoped lang="scss">
  .commonLiStyle {
    width: 100%;
    background-color: #f9f9f9;
    overflow-x: hidden;
  }

  /* banner */
  .bannerFirst {
    height: 67px;
    cursor: pointer;
    background: url('../../assets/images/NewBanner.png') no-repeat center center;
    background-size: auto 100%;
  }

  /* 公共 */
  .commonLiContainer {
    display: flex;
    justify-content: center;
    padding: 60px 50px;
    background-color: #FFDDB0;
  }

  .commontent {
    padding: 74px 100px 50px 100px;
    background-color: #fff;
    font-family: PingFang-SC-Bold;
  }

  /* title */
  .titleMap {
    color: #000;
    font-size: 40px;
  }

  .letterTitle {
    color: #333;
    font-size: 16px;
    margin-top: 10px;
    margin-bottom: 68px;
  }

  /* 1 */
  .twodiv {
    color: #333;
    font-size: 16px;
    margin-top: 10px;
    line-height: 25px;
    text-align: left;
  }

  /* 2 */
  .threediv {
    margin: 20px auto;
  }

  table {
    border-collapse:collapse;
  }

  table td {
    padding: 15px;
    border: 1px solid #000;
  }

  img {
    max-width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/ChildPages/Product-Xiaodugui.vue